import MobilePriceSection from './MobilePriceSection';

export default MobilePriceSection;
